<template id="flash-message">
  <div
    v-if="isOpened"
    id="js-flash"
    :class="[{
      'DropNotice--warning': type === 'warning',
      'DropNotice--danger': type === 'error',
      'DropNotice--success': type === 'success' || type === 'info',
    }, 'DropNotice', 'is-opened']"
  >
    <a
      href="#"
      class="close"
      @click.prevent="isOpened = false"
    >
      <span class="icon-cross" />
    </a>
    <div class="DropNotice-iconContainer">
      <div class="DropNotice-icon warning">
        <img
          src="../../../images/warning-icon.svg"
          alt="warning"
        >
      </div>
      <div class="DropNotice-icon success">
        <img
          src="../../../images/success-icon.svg"
          alt="success"
        >
      </div>
    </div>
    <div class="DropNotice-copy">
      <div v-if="messageHasBreakLines">
        <p
          v-for="singleLine in messageSplitIntoLines"
          :key="singleLine"
        >
          {{ singleLine }}
        </p>
      </div>
      <p v-else>
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      text: null,
      type: null,
      isOpened: false,
      time: 5000,
    };
  },
  computed: {
    messageHasBreakLines() {
      return this.text.indexOf('<rmp-break-line>') > -1;
    },
    messageSplitIntoLines() {
      return this.text.split('<rmp-break-line>');
    },
  },
  created() {
    // listen to the event displayMsg from EventBus and show the flash message
    this.$bus.$on('displayMsg', (event) => {
      this.updateFlashMessage(event);
    });
  },
  methods: {
    // Show flash message then hide it after a set time
    updateFlashMessage(message) {
      const timeOpen = message.duration || this.time;
      this.text = message.text;
      this.type = message.type;
      this.isOpened = true;
      setTimeout(() => {
        this.closeFlashMessage();
      }, timeOpen);
    },
    // dismiss flash message
    closeFlashMessage() {
      this.text = null;
      this.type = null;
      this.isOpened = false;
    },
  },
};
</script>
